export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// /Users/darlacameron/projects/feature-federal-children-shelters-2018-06/node_modules/d3-random/src/defaultSource.js
// module id = null
// module chunks = 